import { resolveBrand } from "./index.js";

/** Public identity only. Never sends cookies, tokens, or browser preview state. */
export async function readPublishedBrand(
  url,
  { fetchImpl = globalThis.fetch } = {},
) {
  const response = await fetchImpl(url, {
    credentials: "omit",
    cache: "no-store",
    signal: AbortSignal.timeout(2000),
  });
  if (!response.ok) throw new Error("Published brand unavailable");
  return resolveBrand((await response.json())?.brandId).id;
}

/** One page-owned subscription. Cleanup prevents HMR/React remount poll leaks. */
export function watchPublishedBrand(
  controller,
  url,
  { target = globalThis.window, read = readPublishedBrand } = {},
) {
  if (!target) return () => {};
  let stopped = false;
  let pending = false;
  const refresh = async () => {
    if (pending || stopped) return;
    pending = true;
    const before = controller.getPublishedRevision();
    try {
      const id = await read(url);
      if (!stopped && controller.getPublishedRevision() === before)
        controller.setPublishedBrand(id);
    } catch {
      // Keep the last published choice (or the initial safe default).
    } finally {
      pending = false;
    }
  };
  void refresh();
  const timer = target.setInterval(refresh, 30_000);
  target.addEventListener("focus", refresh);
  return () => {
    stopped = true;
    target.clearInterval(timer);
    target.removeEventListener("focus", refresh);
  };
}
